import React, { useCallback, useState } from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Cookies from "js-cookie";
import { contactEmail } from "../enums";

const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(),
  },
  subheading: {
    fontWeight: 600,
    textAlign: "center",
    marginBottom: theme.spacing(),
  },
  list: {
    paddingLeft: theme.spacing(3),
    marginTop: 0,
    marginBottom: theme.spacing(),
  },
  listItem: {
    marginBottom: theme.spacing(0.5),
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(2),
  },
  logo: {
    maxWidth: 120,
    height: "auto",
  },
}));

const cookieName = "showed-vacation-modal";

export default () => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(!!!Cookies.get(cookieName));

  const onClose = useCallback(() => {
    Cookies.set(cookieName, "1", {
      expires: new Date(new Date().getTime() + 15 * 60 * 1000),
    });

    setIsOpen(false);
  }, []);

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        Important Update Regarding PSA Bulk &amp; Value Submissions
      </DialogTitle>
      <DialogContent>
        <div className={classes.logoContainer}>
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          <img className={classes.logo} src="/images/psa.png" alt="PSA" />
        </div>
        <Typography className={classes.subheading}>
          Notice to Our Valued Clients
        </Typography>
        <Typography className={classes.section}>
          Due to extraordinary demand, PSA has temporarily paused all Bulk and
          Value grading service levels.
        </Typography>
        <Typography className={classes.subheading}>
          What this means for you:
        </Typography>
        <ul className={classes.list}>
          <li className={classes.listItem}>
            <Typography>
              <strong>We are still accepting cards:</strong> Gem Mint
              Submissions will continue to accept, prepare, and review your
              cards for grading.
            </Typography>
          </li>
          <li className={classes.listItem}>
            <Typography>
              <strong>Bulk submissions are on hold:</strong> We cannot submit
              cards at standard Bulk/Value pricing until PSA reopens these
              tiers.
            </Typography>
          </li>
          <li className={classes.listItem}>
            <Typography>
              <strong>Expedited options are available:</strong> If you do not
              want to wait, we can still submit your cards immediately using
              PSA&apos;s higher-tier, expedited service levels.
            </Typography>
          </li>
        </ul>
        <Typography className={classes.section}>
          For more information on current options or pricing, please feel free
          to email us at{" "}
          <a href={`mailto:${contactEmail}`}>{contactEmail}</a>.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="outlined" onClick={onClose}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};
